import React from 'react';
import ReactDOM from 'react-dom/client';
import PitchDeck from '../Pitchdeck';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <PitchDeck />
  </React.StrictMode>
);
